import { Logger } from '@Ravnur-Inc/logger';
export default new Logger('AdvancedSearch. Transformes.');
